import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import PaginationComp from "../../../common/ui/view/pagination/PaginationComp";
import {
    getAllUserNotification,
} from "../../../services/adminApiService/grievanceTicket/grievanceTicketApis";
import PageTitle from "../../layouts/PageTitle";
import {jwtDecode} from "jwt-decode";

// const allowedCharsRegex = /^[a-zA-Z0-9?()&'\-,.\s]*$/;

//colors
// file extension check regex
export const formatOFTicketRegex = /.(jpe?g|png)$/i;

function UserNotification() {
  const [currentpage, setCurrentPage] = useState(1); //current pages
  const [totalPages, setTotalPages] = useState(null); //total pages
  const [data, setData] = useState({});
  const access_token = localStorage.getItem("access_token_admin");





  //fetch Notification data
  const fetchAllNotificationData = useCallback(async (currentpage) => {

    if (!access_token) {
      console.error("Access token is missing. Please log in.");
      return;
    }

    const decoded = jwtDecode(access_token);
    console.log(decoded)

    try {
      let res = await getAllUserNotification( {currentpage,decoded} );
      console.log(res?.data)
      setTotalPages(res?.data?.data?.last_page);
      setData(res?.data?.data);
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  useEffect(() => {
    fetchAllNotificationData(currentpage);
  }, [currentpage, fetchAllNotificationData]);


  return (
    <>
      <PageTitle
        activeMenu="notification"
        motherMenu="Notification"
      />
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <div className="w-100 table-responsive">
              <div id="example_wrapper" className="dataTables_wrapper">
                <table id="example" className="display w-100 dataTable">
                  <thead>
                    <tr>
                      <th>SN</th>
                     {/* <th>Notification Status</th> */}
                      <th>title</th>
                      <th>Message</th>
                      {/* <th>Url</th> */}
                      <th>Attachment Name</th>
                      <th>Attachment </th>
                       <th>Url Link </th>
                       <th>Created At </th>
                      {/* <th>View Detail</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.length > 0 ? (
                      data?.data?.map((item, index) => (
                        <tr key={index}>
                          <td>{(currentpage - 1) * 10 + index + 1}</td>

                         
                       
                          <td>{item.Title}</td>
                          <td
                            className="text-wrap"
                            style={{ maxWidth: "200px" }}
                          >
                            {item.message?.length > 10
                              ? item.message.substring(0, 10) + "..."
                              : item.message
                            }
                          </td>
                          
                          <td>{item.attachment_name}</td>

                          <td>
                            {item?.attachment_url ? (
                              formatOFTicketRegex.test(
                                item?.attachment_url
                              ) ? (
                                <img
                                  src={item?.attachment_url}
                                  alt={item?.department}
                                  style={{ width: "50px", height: "auto" }}
                                  onClick={() =>
                                    window.open(
                                      item?.attachment_url,
                                      "_blank"
                                    )
                                  }
                                />
                              ) : (
                                <a
                                  href={item?.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View PDF
                                </a>
                              )
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td>{item.url}</td>
                          <td>{new Date(item.created_at).toLocaleDateString()}</td>
                             
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          Data is not available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-center py-2">
                 { console.log("totalPages", totalPages, "currentpage", currentpage) }
                  <PaginationComp
                    size={totalPages}
                    setCurrentPage={setCurrentPage}
                    currentpage={currentpage}
                    gutter={true}
                    variant={""}
                    bg={true}
                    circle={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserNotification;
